import {createContext, useContext} from "react";
import {Scene} from "@/scenes/Scene.ts";
import Encounter from "@/encounter/model/Encounter.ts";

export type PlayerDisplay =
    | { display: 'campaign' }
    | { display: 'encounter'; encounter: PlayerViewContentSummary }
    | { display: 'scene'; scene: PlayerViewContentSummary };

export type PlayerViewContentSummary = {id: string; name: string};

export type PlayerViewSelection =
    | {type: "NONE"; revision: number}
    | {type: "ENCOUNTER"; encounterId: string; encounterName: string; revision: number}
    | {type: "SCENE"; sceneId: string; sceneName: string; revision: number};

export type PlayerViewSelectionUpdate =
    | {type: "NONE"}
    | {type: "ENCOUNTER"; encounterId: string}
    | {type: "SCENE"; sceneId: string};


export type PlayerViewReturn = {
    display: PlayerDisplay;
    displayEncounter: (encounter: Encounter) => Promise<boolean>;
    displayScene: (scene: Scene) => Promise<void>;
    displayCampaign: () => Promise<void>;
    loading: boolean;
    error: boolean;
}

export const PlayerViewContext = createContext<PlayerViewReturn | undefined>(undefined)

export const usePlayerView = (): PlayerViewReturn => {
    const context = useContext(PlayerViewContext);
    if (!context) throw new Error('usePlayerView must be used within a Provider');
    return context;
};
